import { useRef, useState } from "react";
import { toast } from "sonner";
import { Download, Upload, DatabaseBackup, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { PageTitle, Card, GoldButton, GhostButton } from "@/admin/ui";

export const BackupPanel = () => {
  const [loading, setLoading] = useState(false);
  const fileRef = useRef(null);

  const exportBackup = async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/admin/backup/export");
      const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = `backup-grupo-manga-${new Date().toISOString().slice(0, 10)}.json`;
      a.click();
      toast.success("Backup exportado");
    } catch { toast.error("Erro ao exportar"); }
    finally { setLoading(false); }
  };

  const importBackup = async (file) => {
    if (!file) return;
    if (!window.confirm("Importar substituirá jogos, prompts e configurações atuais. Continuar?")) return;
    try {
      const text = await file.text();
      const data = JSON.parse(text);
      await api.post("/admin/backup/import", {
        games: data.games ?? null,
        prompts: data.prompts ?? null,
        settings: data.settings ?? null,
      });
      toast.success("Backup importado com sucesso");
    } catch { toast.error("Arquivo de backup inválido"); }
  };

  return (
    <div data-testid="admin-backup">
      <PageTitle title="Backup & Restauração" subtitle="Exporte ou restaure todo o conteúdo do site" />

      <div className="grid md:grid-cols-2 gap-6">
        <Card>
          <DatabaseBackup className="w-6 h-6 text-[#F5C542] mb-3" />
          <h3 className="font-display font-bold text-white text-lg">Exportar Backup</h3>
          <p className="text-sm text-white/50 mt-2 mb-5">
            Gera um arquivo JSON com todos os jogos, prompts e configurações.
          </p>
          <GoldButton onClick={exportBackup} disabled={loading} data-testid="backup-export">
            <Download className="w-4 h-4 inline mr-1" /> {loading ? "Exportando..." : "Exportar Agora"}
          </GoldButton>
        </Card>

        <Card>
          <Upload className="w-6 h-6 text-[#F5C542] mb-3" />
          <h3 className="font-display font-bold text-white text-lg">Importar / Restaurar</h3>
          <p className="text-sm text-white/50 mt-2 mb-5">
            Carregue um arquivo de backup para restaurar o conteúdo.
          </p>
          <GhostButton onClick={() => fileRef.current?.click()} data-testid="backup-import">
            <Upload className="w-4 h-4 inline mr-1" /> Selecionar Arquivo
          </GhostButton>
          <input ref={fileRef} type="file" accept="application/json" className="hidden" onChange={(e) => importBackup(e.target.files[0])} data-testid="backup-file-input" />
          <div className="flex items-start gap-2 mt-5 text-[11px] text-[#FFD84D]/80">
            <AlertTriangle className="w-3.5 h-3.5 shrink-0 mt-0.5" />
            A restauração substitui os dados atuais. Faça um export antes.
          </div>
        </Card>
      </div>
    </div>
  );
};
